export default __webpack_public_path__ + "static/media/slide3.e2706999.jpg";